import React from "react";
import OfferLetter from "../OfferLetter/OfferLetter";

const AppointmentLetter = () => {
  return (
    <OfferLetter
      letterLabel="Appointment Letter"
      listHeading="My Appointment Letters"
      detailRoutePrefix="/user_dashboard/appointment-letter"
      letterType="appointment"
    />
  );
};

export default AppointmentLetter;
